export default function GridModalTitle({ title }: { title: string }) {
  return (
    <div className="px-6 pt-5 pb-4 flex-shrink-0">
      <div className="items-start ">
        <h2 className="text-[24px] font-pretendard font-bold text-[#0E59C6] text-center">
          {title}
        </h2>
      </div>
    </div>
  );
}
